export const privacyData = [
  {
    id: 1,
    para: "We / Us / Our (“Scoo EV”): shall mean Sigrid Spectrum Consultants Private Limited a company incorporated in India and having its registered office at #2236,1st Floor ,23rdCross,BSK 2nd stage,Bangalore -560070. You / Yours (“You /Yours”) a person who rents and uses a bicycle, electric bicycle, electric scooter, or other device from Sigrid Spectrum Consultants Private Limited. This privacy policy is an electronic record in the form of an electronic contract formed under the information technology act, 2000 and the rules made thereunder and the amended provisions pertaining to electronic documents / records in various statutes as amended by the information technology act, 2000. This privacy policy does not require any physical, electronic or digital signature. This Privacy policy is a legally binding document between You and Sigrid Spectrum Consultants Private Limited. If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. This document is published and shall be construed in accordance with the provisions of the information technology (reasonable security practices and procedures and sensitive personal data of information) rules, 2011 under information technology act, 2000; that require publishing of the privacy policy for collection, use, storage and transfer of sensitive personal data or information. Scoo EV collects data that are generated when its services are used to help it offer its customers optimum solutions. This page explains which personal data Scoo EV collects and the purposes for which it uses that data. The information that we request will be retained by us and used as described in this privacy policy. Please review this Privacy Policy carefully so that you understand Scoo EV’s privacy practices. If you do not agree to this Privacy Policy, do not use any of our Services or give us any of your personal information. In addition, please review Scoo EV’s T&Cs, which may apply to your use of our Services. This Privacy Policy is incorporated by reference into Scoo EV’s T&Cs and will be applicable to users using both Scoo EV website and Scoo EV Mobile Application (all OS versions). ",
  },
  {
    id: 2,
    heading: "Scope",
    describe: [
      {
        id: 1,
        des: "This statement is geared towards anyone who uses Scoo EV services, in particular our vehicles.  ",
      },
      {
        id: 2,
        des: "The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at Scoo EV unless otherwise defined in this Privacy Policy. ",
      },
    ],
  },
  {
    id: 3,
    heading: "Data Security",
    describe: [
      {
        id: 1,
        des: "Scoo EV protects personal data by implementing appropriate safety measures and storing the data on secure servers.   ",
      },
      {
        id: 2,
        des: "The website has suitable technical and organisational features to secure especially personal data against loss, destruction and manipulation and to prevent it being accessed, modified or shared by unauthorised parties. Particularly sensitive data (e.g. login details for user accounts, location and movement data) is encrypted (SSL) when transmitted over the Internet.  ",
      },
    ],
  },
  {
    id: 4,
    heading: "Data collected and Intended purpose ",
    describe: [
      {
        id: 1,
        des: "When an account is opened, the following data is collected: 3.1.1. Private individuals: gender, first name, surname, date of birth, address, telephone number, e-mail address, driving licence details (including place of origin and nationality) and language of correspondence;  ",
      },
      {
        id: 2,
        des: "Internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, user location, Bluetooth address, Wi-Fi MAC address. ",
      },
      {
        id: 3,
        des: "Camera access to the mobile device may be required for examining the driver’s or ID card, as well as for taking customer’s photo (moving photo or video recording) as well as Location information will also be collected. Scoo EVrequires this data for the purposes of concluding contracts and processing reciprocal contractual services. ",
      },
      {
        id: 4,
        des: "When you use an Scoo EV vehicle and the Scoo EV app, we collect anonymous data relating to the location and movements of the vehicle (location of the vehicle, duration of use), as well as data relating to the location and movements of your mobile phone or other end device via the app. In providing this data, you are helping us best manage our services and fleet, giving us valuable information that helps us improve and expand our range so that we can align it more closely with our customers’ needs. ",
      },
      {
        id: 5,
        des: "We collect and use the information that you share with us when you reserve an Scoo EV vehicle or make use of our services via the website or app (location, time and duration of use, type of vehicle, route driven, etc.). We require this information for the purposes of processing reciprocal contractual services.",
      },
      {
        id: 6,
        des: " Our primary goal in collecting your information is to provide you with an enhanced experience when using the Services. We use your information to closely monitor which features of the Services are used most, to allow you to view your trip history, rate trips, and to determine which features we need to focus on improving, including usage patterns and geographic locations to determine where we should offer or focus services, features and/or resources.",
      },
      {
        id: 7,
        des: "The app does use third party services that may collect information used to identify you. Link to privacy policy of third-party service providers used by the app. ",
      },
      {
        id: 8,
        des: "Google Play Services  ",
      },
      {
        id: 9,
        des: "We may use the information obtained from you to prevent, discover and investigate violations of this Privacy Policy or any applicable terms of service or terms of use for the Mobile Application, and to investigate fraud, chargeback or other matters. ",
      },
      {
        id: 10,
        des: " Information captured by the website, Scoo EV captures the following information from the users though the website usage to ensure a quality service of the Scoo EV vehicle renting and/or vehicle sharing solution. The data points mentioned here are an indication of the type of data captured and are not limited to the ones mentioned here. Registration details – Only to contact the user based on his approval to be contacted such as Name, phone number, email etc., ",
      },
      {
        id: 11,
        des: " Information captured through the Mobile Application, Scoo EV captures the following information from the users though the Mobile app usage to ensure a quality service of the Scoo EV vehicle renting and/or vehicle sharing solution. The data points mentioned here are an indication of the type of data captured and are not limited to the ones mentioned here. Mandatory: Name / Gender / Email ID/ Date of Birth / Phone number/ Adhaar card/ Driving licence / OS details & version Optional: Work email / user’s picture / GPS location/ Work or Home location or any other favorite locations/ Pan Card",
      },
    ],
  },
  {
    id: 5,
    heading: " Data Security ",
    describe: [
      {
        id: 1,
        des: "Scoo EV makes a reasonable and sensible effort to ensure that your information is secure on its system. For example, Scoo EV works to protect the security of your information during transmission by using Secure Sockets Layer (SSL) software, which encrypts information in transit. Scoo EV has staff dedicated to maintaining the privacy of information that its Users provide.  ",
      },
      {
        id: 2,
        des: " However, Scoo EV is not liable for an unauthorized breach of Scoo EV’s security and protection protocols (i.e., if Scoo EV’s electronic files are “hacked”), and you agree that you will not seek damages from Scoo EV, and that Scoo EV shall not be liable for any damages incurred by you, in the event your personal information is stolen or otherwise secured from Scoo EV’s database of users, unless Scoo EV is grossly negligent in maintaining the security of its database and other personal information.",
      },
      {
        id: 3,
        des: "Your Scoo EV profile is password-protected so that only you and authorized Scoo EV employees and agents have access to your personal account information. If you have registered for Scoo EV using Facebook, then your login and password shall be the same as your Facebook login and password.",
      },
    ],
  },
  {
    id: 4,
    heading: "Cookies and Web Analysis",
    describe: [
      {
        id: 1,
        des: "Log Data: We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.",
      },
      {
        id: 2,
        des: "Cookies: Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device’s internal memory. This Service does not use these “cookies” explicitly. However, the app may use third party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you wish, you can prevent cookies from being installed by adjusting the corresponding settings in your browser software; if you do, you may not be able to make full use of all the website’s functions.",
      },
    ],
  },
  {
    id: 4,
    heading: "Disclosing data to Third Parties",
    describe: [
      {
        id: 1,
        des: "We may employ third-party companies and individuals due to the following reasons: ",
      },
      {
        id: 2,
        des: "To facilitate our Service; ",
      },
      {
        id: 3,
        des: "To provide the Service on our behalf;  ",
      },
      {
        id: 4,
        des: "To perform Service-related services; or ",
      },
      {
        id: 5,
        des: "To assist us in analysing how our Service is used. ",
      },
      {
        id: 6,
        des: " We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.",
      },
      {
        id: 7,
        des: "We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security. ",
      },
      {
        id: 8,
        des: "You should know that Scoo EV is required to cooperate with appropriate government and law enforcement officials and private parties to enforce and comply with applicable laws and court orders. As a result, Scoo EV may access, use, preserve, transfer and disclose your information (including Personal Information), including disclosing this information to third parties such as government or law enforcement officials, in its sole discretion, reasonably determines is necessary and appropriate:",
      },
      {
        id: 9,
        des: "To satisfy any applicable law, regulation, governmental requests or legal process; ",
      },
      {
        id: 10,
        des: "To protect and/or defend Scoo EV’s Terms of Use regarding the Services, including investigation of potential violations of the Terms of Use;  ",
      },
      {
        id: 11,
        des: " To protect the safety, rights, property or security of Scoo EV and the passengers who use the Services, or any third party that uses or provides services to Scoo EV;",
      },
      {
        id: 12,
        des: " To protect the safety of the public for any reason; ",
      },
      {
        id: 13,
        des: "To detect, prevent or otherwise address fraud, security or technical issues; and/or",
      },
      {
        id: 14,
        des: "To prevent or stop activity we may consider to be, or believe poses a risk of being, an illegal, unethical, or legally actionable activity.",
      },
      {
        id: 15,
        des: " Further, Scoo EV may use your IP address, GPS provided location, or other information that identifies you and/or your mobile device, and may do so in cooperation with third parties such as copyright owners, internet service providers, wireless service providers and/or law enforcement agencies, including disclosing such information to third parties, all in our discretion. Such disclosures may occur without providing any notice to you. ",
      },
      {
        id: 14,
        des: " Links to Other Sites: This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.",
      },
      {
        id: 14,
        des: "Children’s Privacy: These Services do not address anyone under the age of 13yrs. We do not knowingly collect personally identifiable information from children aged under 13 yrs. In the case we discover that a child under 13yrs of age has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to take the necessary actions.",
      },
    ],
  },

  {
    id: 5,
    heading: "Retention of Information ",
    describe: [
      {
        id: 1,
        des: " To preserve the integrity of the information that Scoo EV receives from, and maintains regarding, its Users, including you, and to comply with applicable statutes and regulations, Scoo EV maintains its databases and the personal information that you and all Users provide for an indefinite length of time.",
      },
      {
        id: 2,
        des: "By creating an account with Scoo EV and/or using SRide’s Services, you consent to Scoo EV’s use of your personal information and acknowledge that Scoo EV may maintain your information in one place for this indefinite length of time. Scoo EV will keep the user’s information for a minimum of 10 years and may archive it based on Scoo EV’s discretion. Scoo EV may also archive Users’ accounts, including yours, and the information that SRide maintains regarding those accounts, upon your written request.",
      },
      {
        id: 3,
        des: "By using the Services, you represent and warrant that you understand and agree that all information submitted by you to Scoo EV shall become and remain the property of Scoo EVand may be used at Scoo EV’s sole discretion in accordance with this Privacy Policy and its Terms of Use. ",
      },
    ],
  },
  {
    id: 6,
    heading: "Your Choices and How Do You Opt-Out ",
    describe: [
      {
        id: 1,
        des: "Although you may not be able to opt-out of all data collection when you visit our Apps, you do have a choice to limit the collection, use and sharing of your personally identifiable information",
      },
    ],
  },
  {
    id: 7,
    heading: "Force Majeure ",
    describe: [
      {
        id: 1,
        des: "In any event that takes place beyond our reasonable control and shall include, without limitation, flood, explosion, acts of God, civil commotion, strikes or industrial action of any kind, riots, insurrection, war, acts of government, computer hacking, unauthorised access to computer, computer system or computer network, computer crashes, breach of security and encryption (which is beyond reasonable control) power or electricity failure or unavailability of adequate backup, archival, and/or audit purposes. If you have any questions about deactivation or termination of your account, please contact us directly at support info@scooev.com power or electricity we shall not be held responsible for any loss, damage or misuse of your Information. ",
      },
    ],
  },
  {
    id: 8,
    heading: "How Long Do We Keep Your Information ",
    describe: [
      {
        id: 1,
        des: "Following deactivation or termination of your account, Scoo EV, its Affiliates or Clients shall retain information (including your profile information) and user Content for a commercially reasonable time for backup, archival, and/or audit purposes. If you have any questions about deactivation or termination of your account, please contact us directly at info@scooev.com ",
      },
    ],
  },
  {
    id: 9,
    heading: "Changes to This Privacy Policy ",
    describe: [
      {
        id: 1,
        des: "We reserve the right to modify, amend, update, suspend, terminate, or replace this Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.  ",
      },
    ],
  },
  {
    id: 10,
    heading: "Governing Law & Jurisdiction  ",
    describe: [
      {
        id: 1,
        des: "This Privacy Policy shall be governed by and construed in accordance with the laws of India. In case of any dispute regarding the Privacy Policy shall be subject to the jurisdiction of Bangalore.(Karnataka). ",
      },
    ],
  },
  {
    id: 11,
    heading: "Declaration of consent ",
    describe: [
      {
        id: 1,
        des: "In using our services, you declare that you agree with Scoo EV's data protection policy as described in this privacy statement.  ",
      },
    ],
  },
  {
    id: 12,
    heading: "Contact  ",
    describe: [
      {
        id: 1,
        des: "In case you would like to change, delete or amend any of your details shared with us or you have any questions or suggestions for improvement concerning this privacy statement, please contact us at info@scooev.com We shall address your reasonable concern within a reasonable amount of time.  ",
      },
    ],
  },
];
